import { TextComponent } from '@g.frame/components.text';
import { Color, DoubleSide, Group, MeshBasicMaterial, Shape, ShapeGeometry, Vector2 } from 'three';
import { Factory, GMesh, ParentEvent, RoundedPlane, ViewerModule } from '@g.frame/core';
import { ActionController, ActionControllerEventName } from '@g.frame/common.action_controller';
const getStyleConfig = () => ({
    main: {
        background: {
            top: new Color('#432A1C'),
            bottom: new Color('#E5E6E0'),
            bottomHovered: new Color('#9DC458'),
        },
        radius: 0.075,
        text: {
            // margin: 0.5,
            margin: 0.1,
            color: new Color('#63615E'),
            colorHovered: new Color('#FFFFFF')
        }
    },
});
export default class TooltipComponent extends ViewerModule {
    constructor(options, modulesProcessor) {
        super();
        this.options = options;
        this.modulesProcessor = modulesProcessor;
        this.hovered = false;
        this.background = {
            group: undefined,
            top: undefined,
            bottom: undefined,
        };
        this.canvasContainer = document.getElementById('app');
        this.options.pxScale = this.options.pxScale || 1;
        this.styleConfig = getStyleConfig();
        this.styleConfig.main.radius = this.options.size.x * 0.02;
        this.modulesProcessor.agents.get(ActionController).on(ActionControllerEventName.click, this.uiObject, (event) => {
            this.fire('clicked', new ParentEvent('clicked'));
        });
        this.modulesProcessor.agents.get(ActionController).on(ActionControllerEventName.over, this.uiObject, (event) => {
            this.canvasContainer.classList.add('cur_pointer');
        });
        this.modulesProcessor.agents.get(ActionController).on(ActionControllerEventName.out, this.uiObject, (event) => {
            this.canvasContainer.classList.remove('cur_pointer');
        });
        this.uiObject.name = 'TooltipComponent';
    }
    init() {
        const borderHeight = this.options.size.y * 0.3;
        const bodySize = new Vector2(this.options.size.x - this.styleConfig.main.text.margin * 2 * this.options.textScale, this.options.size.y - this.styleConfig.main.text.margin * 2 * this.options.textScale);
        this.addObject(this.background.group = new Group());
        const roundedPlaneTopOptions = {
            width: this.options.size.x,
            height: borderHeight,
            color: this.styleConfig.main.background.top.getHex(),
            r1: this.styleConfig.main.radius,
            r2: this.styleConfig.main.radius,
            r3: 0,
            r4: 0,
        };
        const backgroundInner = RoundedPlane.getRoundedPlane(roundedPlaneTopOptions);
        backgroundInner.position.set(0, this.options.size.y / 2 - borderHeight / 2, 0);
        this.background.top = backgroundInner;
        this.background.group.add(backgroundInner);
        this.arrowsShape = this.getArrowsShape();
        this.updateBottomBackground();
        this.updateArrows();
        this.addObject(this.bodyText = this.modulesProcessor.agents.get(Factory).getFactory(TextComponent)({
            size: bodySize,
            pxSize: new Vector2(256 * bodySize.x / bodySize.y * this.options.pxScale, 256 * this.options.pxScale),
            text: {
                value: this.options.text,
                autoWrappingHorizontal: false,
                autoWrapping: false,
                align: 'center',
                style: {
                    family: 'Ubuntu',
                    weight: '700',
                    size: '80px',
                    color: this.styleConfig.main.text.color.getStyle()
                },
                lineHeight: 80,
            },
            background: {
                color: this.styleConfig.main.background.bottom.getStyle(),
            }
        }));
        this.bodyText.uiObject.position.set(0, -borderHeight / 2, 0.01);
    }
    getArrowsShape() {
        const shape = new Shape();
        const width = this.options.size.x * .3;
        const heigth = this.options.size.y * .3;
        shape.moveTo(-width / 2, 0);
        shape.lineTo(0, -heigth);
        shape.lineTo(width / 2, 0);
        return shape;
    }
    updateArrows() {
        if (this.arrows)
            this.disposeObject(this.arrows);
        this.arrows = new GMesh(new ShapeGeometry(this.arrowsShape), new MeshBasicMaterial({
            color: this.hovered ?
                this.styleConfig.main.background.bottomHovered.getHex()
                : this.styleConfig.main.background.bottom.getHex(),
            side: DoubleSide
        }));
        this.addObject(this.arrows);
        this.arrows.position.set(0, -this.options.size.y / 2, 0);
    }
    updateBottomBackground() {
        if (this.background.bottom)
            this.disposeObject(this.background.bottom);
        const roundedPlaneBottomOptions = {
            width: this.options.size.x,
            height: this.options.size.y,
            color: this.hovered ?
                this.styleConfig.main.background.bottomHovered.getHex()
                : this.styleConfig.main.background.bottom.getHex(),
            r1: this.styleConfig.main.radius,
        };
        const backgroundBorder = RoundedPlane.getRoundedPlane(roundedPlaneBottomOptions);
        backgroundBorder.position.set(0, 0, -0.003);
        backgroundBorder.name = 'backgroundBorder';
        this.background.bottom = backgroundBorder;
        this.background.group.add(backgroundBorder);
    }
    updateHoveredColor() {
        this.bodyText.options.text.style.color = this.hovered ?
            this.styleConfig.main.text.colorHovered.getStyle()
            : this.styleConfig.main.text.color.getStyle();
        this.bodyText.options.background.color = this.hovered ?
            this.styleConfig.main.background.bottomHovered.getStyle()
            : this.styleConfig.main.background.bottom.getStyle();
        this.bodyText.updateElement(this.bodyText.options);
        this.updateBottomBackground();
        this.updateArrows();
    }
    setHovered(hovered) {
        if (this.hovered === hovered)
            return;
        this.hovered = hovered;
        this.updateHoveredColor();
    }
}
